module.exports = __webpack_public_path__ + "img/banner.8f925f3b.jpeg";